var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlanWhiteIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "KASOOKOO_CAMPAIGN_MANAGER",
    "data-name": "KASOOKOO CAMPAIGN MANAGER",
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.479,
    height: 34,
    viewBox: "0 0 35.479 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_19386",
    "data-name": "Path 19386",
    d: "M8.75,17.612v6.856a1.108,1.108,0,0,0,2,.656l4.011-5.458Z",
    transform: "translate(4.185 8.423)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_19387",
    "data-name": "Path 19387",
    d: "M35.012.206a1.109,1.109,0,0,0-1.156-.08L.6,17.5a1.109,1.109,0,0,0,.154,2.033L10,22.688,29.688,5.851,14.45,24.209l15.5,5.3a1.134,1.134,0,0,0,.358.059,1.108,1.108,0,0,0,1.1-.945L35.466,1.273A1.111,1.111,0,0,0,35.012.206Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanWhiteIcon);
export default __webpack_public_path__ + "static/media/plan_white_icon.e2fe77e3bbdb7d7af15e0f6fefb5b760.svg";
export { ForwardRef as ReactComponent };